import { isArabic, viewerMode } from '../global';
import Master from "./Master";
import { Link } from 'react-router-dom';

import "../styles/global.css";

import images from '../images/ovg/images.svg';
import logo_mobile from '../images/Logo_mobile.svg';
import contactus from "../images/ovg/contactus.png";
import language_ar from "../images/ovg/language_ar.png";
import language_en from "../images/ovg/language_en.png";

import step1_ar from "../images/ovg/step1_full_ar.svg";
import step2_ar from "../images/ovg/step2_full_ar.svg";
import step3_ar from "../images/ovg/step3_full_ar.svg";
import step4_ar from "../images/ovg/step4_full_ar.svg";

import step1_en from "../images/ovg/step1_full_en.svg";
import step2_en from "../images/ovg/step2_full_en.svg";
import step3_en from "../images/ovg/step3_full_en.svg";
import step4_en from "../images/ovg/step4_full_en.svg";

import ios from "../images/ios.png";
import android from "../images/android.png";



const Ovg = () => {

    const logoSize = 80 + (viewerMode*25);

    const sloganStr = isArabic ? 'لحظة ماتفوتك':'Make Every Moment Count'
    const subSloganStr = isArabic ? 'مع Jamhoor Hub يوصلك الأكل والمشروبات بسرعة وأمان، بدون ما تفوّت أي لحظة.':'With Jamhoor Hub, food & drinks arrive fast and safe — never miss a moment.'
    const orderStr = isArabic?'اطلب الآن':'Order Now'

    const step1 = isArabic?step1_ar:step1_en
    const step2 = isArabic?step2_ar:step2_en
    const step3 = isArabic?step3_ar:step3_en
    const step4 = isArabic?step4_ar:step4_en


    return (
        
        <Master root='ovg' withBG={false} withHeader={false}>
           
            

                <br/>
                {/* HEADER */}
                <div className="Ovgcontent">
                    <section className='Row MainSpaceBetween CrossStart'>
                        <img src={logo_mobile} width='50%'/>
                        
                            <section className='Row MainEnd CrossCenter'>
                                <Link to={isArabic?'/en/ovg':'/ar/ovg'}>
                                    <img src={isArabic?language_en:language_ar} width={'100px'} height={'35px'}/>
                                </Link>
                                {/* &nbsp; */}
                                {/* <Link to={isArabic?'/en/ovg':'/ar/ovg'}>
                                    <img src={contactus} width={viewerMode==1?'35px':"35px"} /> 
                                </Link> */}
                            </section>
                        
                        &nbsp;
                        
                    </section>
                </div>

                 <img src={images} width='100%'/>

                 <br /><br />
                
                
                <div className="Ovgcontent">
                    
                    {/* SLOGAN */}
                    <div className="OvgSlogan">{sloganStr}</div>
                    <br/>
                    <section className='Row'>
                        <div>&nbsp;&nbsp;&nbsp;</div>
                        <div className="OvgSubSlogan" >{subSloganStr}</div>
                        <div>&nbsp;&nbsp;&nbsp;</div>
                    </section>
                    <br/>

                    {/* ORDER NOW */}
                    <a href="https://jamhoorhub.com/webapp"> <div className="OvgButton" >{orderStr}</div></a>
                    
                    <br/><br/>

                    {/* STEPS */}
                    <section className="Column CrossCenter">
                        <section className="Row MainCenter CrossCenter">
                            <img src={step1} width='50%'/>&nbsp;&nbsp;<img src={step2} width='50%'/>
                        </section>
                        <br/>
                        <section className="Row MainCenter CrossCenter">
                            <img src={step3} width='50%'/>&nbsp;&nbsp;<img src={step4} width='50%'/>
                        </section>
                    </section>


                    <br/><br/>

                    {/* DOWNLOAD */}

                      {/* <a href="https://apps.apple.com/sa/app/id6502456473"><img src={ios} width='150px'/></a>
                        &nbsp;&nbsp;
                        <a href="https://play.google.com/store/apps/details?id=com.jamhoorhub.jamhoorhub"><img src={android} width='150px'/></a> */}

                        {/* <div style={{width:'10%'}}/> */}
                      

                     {/* <section className='Column CrossCenter'>
                    <section className='Row MainCenter'>
                        <a href="https://jamhoorhub.com/webapp"><img src={ios} width='100px'/></a>
                        &nbsp;&nbsp;
                        <a href="https://jamhoorhub.com/webapp"><img src={android} width='100px'/></a>
                    </section>
                    </section> */}


                    {/* FOOTER */}
                    <section className='Row MainCenter' style={{direction:'rtl'}}>
                        <div className='OvgFooter'>كل الحقوق محفوظة - Jamhoor Hub ©</div>
                    </section>

                    

                    <br/><br/>
                </div>

            
        </Master>
    )
    
}

export default Ovg;
